jQuery(window).on("load", function(){

  function set_menu_active (){
    jQuery("nav").addClass("is-active");
  }

  function set_menu_passive(){
    jQuery("nav").removeClass("is-active");
  }

  function appointment_offset(){
    let menu_circle = jQuery("div.menu-circle");
    let circle_offset = (jQuery(window).width() - (menu_circle.offset().left + menu_circle.outerWidth()));
    //circle_offset = circle_offset - 18 //Adjust
    jQuery("div.appointment-note").css("right", circle_offset);
  }

  /*
  function hide_form_status(){
    jQuery(".form_status_alert").css("display","none");
    jQuery("form").removeClass("blur");
  }

  new Event("dropdown_ready");

  function month_convert(month_id){
    switch(month_id){
      case 0:
        return "Januar";
      case 1:
        return "Februar";
      case 2:
        return "März";
      case 3:
        return "April";
      case 4:
        return "Mai";
      case 5:
        return "Juni";
      case 6:
        return "July";
      case 7:
        return "August";
      case 8:
        return "September";
      case 9:
        return "Oktober";
      case 10:
        return "November";
      case 11:
        return "Dezember";
    }
  }
  */

  //Main Slider
  if(jQuery(".slider-container").length){
    //Slider erstellen
    jQuery(".slider-container").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      centerMode: true,
      centerPadding: '25%',
      responsive: [
        {
          breakpoint: 1023,
          settings: {
            centerMode: false,
            centerPadding: "0"  
          }
        }
      ]
    });

    //Slider custom Arrow Even Listener erstellen
    jQuery(".slick-prev").on("click", function(){
      jQuery(".slider-container").slick("slickPrev");
    })
    
    jQuery(".slick-next").on("click", function(){
      jQuery(".slider-container").slick("slickNext");
    })

    
  }

  //Subpage Slider
  if(jQuery(".sub-page-slider")){
    jQuery(".sub-page-slider").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      dots: true,
      adaptiveHeight: false,
      responsive:[
        {
          breakpoint: 640,
          settings: {
            adaptiveHeight: true
          }
        }
      ]
    })

    //Slider custom Arrow Even Listener erstellen
    jQuery(".slick-prev").on("click", function(){
      jQuery(".sub-page-slider").slick("slickPrev");
    })
    
    jQuery(".slick-next").on("click", function(){
      jQuery(".sub-page-slider").slick("slickNext");
    })

  }

  //Menu
  jQuery(".menu-circle").on("click", function(){
    set_menu_active();
  })
  jQuery(".menu-cross").on("click", function(){
    set_menu_passive();
  })
  

  /*
  //Custom Select Calendar
  if(jQuery(".container-calendar").length){
    let year_container = jQuery("#custom-select-year"); //Custom Year Container
    let month_container = jQuery("#custom-select-month");//Custom Month Container
    var prev_selected_date = jQuery("td.selected");//Aktuelles Datum(<td>) in der Tabelle

    let current_month = new Date().getMonth();//Aktueller Monat
    let converted_month = month_convert(current_month);//Aktuellen Monat konvertieren
    let current_day = new Date().getDate();//Aktueller Tag

    //Default Input Date setzen
    current_month = current_month + 1;//Current Month für Input Date um 1 inkrementieren
    var selected_date = [currentYear, current_month, current_day]; //Aktuell ausgewähltes Datum

    if(current_month < 10){
      current_month = 0 + "" + current_month;
    }
    if(current_day < 10){
      current_day = 0 + "" + current_day;
    }
    
    let default_date = currentYear +  "-" + current_month + "-" + current_day;

    jQuery("#calendar-date-input").val(default_date);
    
    //Notiz: Jahr Select Option wird durch calendar.js erstellt

    //Jahre als Custom Option einfügen
    year_container.find("div.select-item-container").append("<div class='select-item calendar-select-item'>" + currentYear + "</div>");
    year_container.find("div.select-item-container").append("<div class='select-item calendar-select-item'>" + nextYear + "</div>");

    //Default Select Option setzen
    year_container.find(".select-header").text(currentYear);// Aktulles Jahr in Select Header einfügen
    month_container.find(".select-header").text(converted_month);// Aktuellen Monat in Select Header einfügen

    //Tabellenitem on Click
    function table_click_listener(){
      jQuery("td.date-picker").on("click", function(){
        //Aktiv Klasse der jeweiligen <td> hinzufügen/entfernen
        prev_selected_date.removeClass("selected");
        jQuery(this).addClass("selected");
        prev_selected_date = jQuery(this);
  
        //Neu gewähltes Datum in Input Date einfügen
        let selected_year = jQuery(this).data("year");
        let selected_month = jQuery(this).data("month");
        let selected_day = jQuery(this).data("date");
        selected_date = [selected_year, selected_month, selected_day];//Selected Date aktualisieren

        if(selected_month < 10){//0 anhängen wenn kleiner als 10
          selected_month = 0 + "" + selected_month;
        }
        if(selected_day < 10){
          selected_day = 0 + "" + selected_day;
        }

        let new_date = selected_year + "-" + selected_month + "-" + selected_day;//Datum zusammenbauen für das Input Date
        
        jQuery("#calendar-date-input").val(new_date);//Value einsetzen
      });
    }

    //Prüfen, ob TD Item das aktuelle Datum ist
    function set_selected_date(){
      jQuery("td.date-picker").each(function(){
        let item_year = jQuery(this).data("year");
        let item_month = jQuery(this).data("month");
        let item_day = jQuery(this).data("date");

        //Werte mit selected_date vergleichen
        if(item_year == selected_date[0] && item_month == selected_date[1] && item_day == selected_date[2]){
          jQuery(this).addClass("selected");
          prev_selected_date = jQuery(this);
        }
        else{
          jQuery(this).removeClass("selected");
        }
      });
    }

    table_click_listener();

    //Bei Klick auf ein Select Item im Kalender
    jQuery(document).on("dropdown_ready", function(){
      jQuery("#month").trigger("onchange");
      jQuery("#year").trigger("onchange");
      table_click_listener();
      set_selected_date();
    });
  }

  //Custom Select
  if(jQuery(".custom-select-container").length){
    let select_container = jQuery(".custom-select-container");

    //Dropdown öffnen / schließen
    select_container.on("click",function(){
      //Wenn Dropdown offen ist
      if(jQuery(this).hasClass("active")){
        jQuery(this).removeClass("active");
      }

      //Wenn Dropdown geschlossen ist
      else if(jQuery(this).hasClass("active") == false){
        jQuery(this).addClass("active");//Dropdown einblenden
        let select_header_text = jQuery(this).find(".select-header").text();//Text des Headers
        jQuery(this).find(".select-item").each(function(){
          let select_item_text = jQuery(this).text(); //Text der Pseudo <option>
          let select_item = jQuery(this);// Pseudo <option> Element
          
          if(select_item_text == select_header_text){//Wenn Item Text == Active Item Text
            select_item.addClass("active");//Select Item auf Aktiv setzen
          }
          else{
            select_item.removeClass("active");//Select Item auf passiv setzen
          }
        });

      }
    });

    //Select Item Klick
    jQuery(".select-item").on("click", function(){
      let original_select = jQuery(this).parent().parent().find("select");
      let select_item_text = jQuery(this).text(); //Text der Pseudo <option>
      let select_header = jQuery(this).parent().parent().find(".select-header");

      original_select.find("option").each(function(){
        if(jQuery(this).text() == select_item_text){
          jQuery(this).prop("selected", true);
          return false;
        }
      });
      select_header.text(select_item_text);
      //Dropdown Ready Event triggern wenn das Select Item zum Calendar Select gehört, damit die Funktionen refreshed werden
      if(jQuery(this).hasClass("calendar-select-item")){
        jQuery(document).triggerHandler("dropdown_ready");
      }
    });
  }

  //Custom Radio Button
  if(jQuery(".radio-button-container").length){
    jQuery(".custom-radio-button").on("click", function(){
      let parent = jQuery(this).parent().parent();// Parent Element mit den Label Feldern
      parent.find(".custom-radio-button").each(function(){//Jedes Label auf passiv stellen
        jQuery(this).removeClass("active");
      })
      jQuery(this).addClass("active");//Angeklicktes Label auf Aktiv stellen
      jQuery(this).find("input").prop("checked", true);//Dazugehöriges Input Radio auf aktiv stellen
    })
  }

  //Custom Checkbox
  if(jQuery(".single-checkbox").length){
    jQuery(".custom-checkbox").on("click", function(){
      if(jQuery(this).hasClass("checked")){
        jQuery(this).removeClass("checked");
        jQuery(this).prev().prop("checked", false);
      }
      else{
        jQuery(this).addClass("checked");
        jQuery(this).prev().prop("checked", true);
      }
    })
  }
  */

  //Jump mark scrolling
  if(jQuery(".jump-mark")){
    if(jQuery(window).width() <= 640){
      var navigation_size = 108;
    }
    else{
      var navigation_size = 134;
    }
    jQuery(".jump-mark").on("click", function(){
      let target = jQuery(this).data("target");
      let target_element = jQuery("#" +  target);
      jQuery("html, body").animate({
        scrollTop: target_element.offset().top - navigation_size
      }, "slow");
    })
  }

  //Expandable Content
  jQuery("div.textbox-container").each(function(){
    let expand_target = jQuery(this).find("div.expandable-content");
    if(expand_target.length == 1){
      jQuery(this).find(".expand-text").on("click", function(){
        jQuery(this).css("display", "none");// Expand button ausblenden
        expand_target.fadeIn(500);// Text einblenden Animation
      })
    }
  })

  /*
  //Form Validate + Alert Box Script
  if(jQuery(".appointment-form").length){

    //Form Status Box schließen
    jQuery(".close_modal").on("click", function(){
      hide_form_status();
    });

    var form_error = 0; // 0 == kein Fehler
    let alert_box = jQuery("#alert-box");

    function validate_form(){
      //Values
      let calendar_input = jQuery("#calendar-date-input").val();
      let appointment_type = jQuery("#appointment-type option:selected").val();
      let insurance_type = jQuery("[name='insurance-type']:checked").val();
      let gender = jQuery("#gender-select option:selected").val();
      let first_name = jQuery("#first-name").val();
      let last_name = jQuery("#last-name").val();
      let phone_number = jQuery("#phone-number").val();
      let email = jQuery("#email-adress").val();
      let privacy_accept = jQuery("#privacy-accept").is(":checked");

      form_error = 0;
      var error_message = [];
      if(calendar_input == null || typeof calendar_input == "undefined" || calendar_input == ""){
        form_error++;
        error_message.push("Es wurde kein Datum ausgewählt!");
      }
      if(appointment_type == null || typeof appointment_type == "undefined" || appointment_type == ""){
        form_error++;
        error_message.push("Es wurde keine Terminart ausgewählt!");
      }
      if(insurance_type == null || typeof insurance_type == "undefined" || insurance_type == ""){
        form_error++;
        error_message.push("Es wurde keine Versicherungsart angegeben!");
      }
      if(gender == null || typeof gender == "undefined" || gender == ""){
        form_error++;
        error_message.push("Sie haben kein Geschlecht ausgewählt!");
      }
      if(first_name == null || typeof first_name == "undefined" || first_name == ""){
        form_error++;
        error_message.push("Es wurde kein Vorname angegeben!");
      }
      if(last_name == null || typeof last_name == "undefined" || last_name == ""){
        form_error++;
        error_message.push("Es wurde kein Nachname angegeben!");
      }
      if(phone_number == null || typeof phone_number == "undefined" || phone_number == ""){
        form_error++;
        error_message.push("Es wurde keine Telefonnummer angegeben!");
      }
      if(email == null || typeof email == "undefined" || email == ""){
        form_error++;
        error_message.push("Es wurde keine E-mail angegeben!");
      }
      if(privacy_accept == null || typeof privacy_accept == "undefined" || privacy_accept == ""){
        form_error++;
        error_message.push("Die Bedinungen für den Datenschutz müssen akzeptiert werden!");
      }

      if(form_error == 0){// Wenn keinFehler
        return true;
      }
      else{//Wenn Fehler
        //Fehlermeldungen in Box pushen
        if(form_error == 1){
          alert_box.append("<p>Es wurde " + form_error + " Fehler gefunden:</p>");
        }
        else{
          alert_box.append("<p>Es wurden " + form_error + " Fehler gefunden:</p>");
        }
        for(var error_index = 0; error_index < error_message.length; error_index++){
          let error_message_element = "<p>" + error_message[error_index] + "</p>";
          alert_box.append(error_message_element);
        }
        alert_box.fadeIn(500);//Alertbox Open Animation

        setTimeout(function(){
          alert_box.fadeOut(500);//Alertbox Close Animation
          alert_box.empty();// Alle Fehlermeldungen wieder entfernen aus der Box
        }, 3000);
        return false;
      }
    }

    jQuery("form").on("submit", function(e){
      let validate = validate_form();
      if(validate !== true){
        e.preventDefault();
      }
    })
    
  }*/

  //Mobile Style Script
  if(jQuery(window).width() <= 640){
    //Nav Container Abstand anpassen
    let menu_bottom_container_height = jQuery("nav div.bottom-container").height();
    let menu_top_container = jQuery("nav div.top-container");
    menu_bottom_container_height = menu_bottom_container_height + 22 + 29; 
    menu_top_container.css("bottom", menu_bottom_container_height)
  }

  //Appointment Note Homepage
  if(jQuery(".div.appointment-note")){
    appointment_offset();
    jQuery(window).on("resize", function(){
      appointment_offset();
    });
  }

  if(jQuery(".slider-container").length){
    if(jQuery(window).width() <= 1025){
      
      //Y Center Mobile
      var window_height = jQuery(window).height();
      var slider_height = jQuery(".slider-container").height();
      var adjust_margin = (window_height - slider_height) / 1.5;
      if(jQuery(window).width() <= 1025 && jQuery(window).width() >= 768){
        var adjust_margin = (window_height - slider_height) / 2 + 120;
      }
      console.log("adjust: " + adjust_margin);
      jQuery(".main-slider").css("margin-top", adjust_margin);
    }
  }

  //Preloader
  setTimeout(function(){
    jQuery(".preloader-container").addClass("passive");
  }, 1000);
  setTimeout(function(){
    jQuery(".preloader-container").remove();
  }, 1500);
})
